module.exports = __webpack_public_path__ + "static/media/404_image.cf294318.png";